import React from "react";
import { Play, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function WelcomeExcellence() {
  return <section data-section-id="28827" id="launch-without-delay" className="relative h-[80vh] min-h-[600px] w-full overflow-hidden bg-[#F8FAFC]">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-white/40 z-10" />
        <div className="h-full w-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577657/img/industrial_hero_bg.png)] bg-cover bg-center bg-no-repeat opacity-20 grayscale" aria-hidden="true" />
      </div>

      {}
      <div className="relative z-20 flex h-full w-full max-w-7xl mx-auto items-center px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-3xl">
          {}
          <p className="mb-4 text-xl font-medium text-[#004D47] md:text-2xl leading-relaxed">
            Acquire curated, legally-vetted trademarks and launch your brand in days, not months.
          </p>

          {}
          <h1 className="mb-8 font-sans text-5xl font-bold leading-tight text-[#001F3F] md:text-6xl lg:text-[80px] tracking-tight">
            Skip the 6–12 Month Brand Name Search.
          </h1>

          {}
          <div className="flex flex-wrap items-center gap-4">
            <Button asChild size="lg" className="h-14 rounded-sm border-none bg-[#FFD700] px-8 text-base font-bold uppercase tracking-wide text-[#001F3F] hover:bg-[#FFD700]/90 shadow-lg transition-all">
              <Link to="/OurCataloguePage">
                Explore Available Brands
              </Link>
            </Button>

            <Button asChild variant="ghost" size="lg" className="group h-14 gap-3 rounded-sm px-6 text-base font-bold text-[#001F3F] hover:bg-[#001F3F]/5 hover:text-[#001F3F] border border-[#001F3F]/20">
              <Link to="/ContactPage">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#001F3F]/10 transition-transform group-hover:scale-110">
                  <Star className="h-4 w-4 fill-[#001F3F] text-[#001F3F]" />
                </div>
                List Your Trademark
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-10 right-4 z-30 hidden md:block lg:bottom-20 lg:right-20">
        <div className="relative flex h-32 w-32 items-center justify-center rounded-full bg-[#FFD700] shadow-2xl backdrop-blur-sm">
          {}
          <div className="absolute inset-0 animate-[spin_12s_linear_infinite]">
            <svg viewBox="0 0 100 100" width="100%" height="100%" className="overflow-visible">
              <path id="textPath" d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0" fill="none" />
              <text className="fill-[#001F3F] text-[10px] font-bold uppercase tracking-widest">
                <textPath href="#textPath" startOffset="0%">
                  Premium Brand Assets • Registered Trademarks •
                </textPath>
              </text>
            </svg>
          </div>
          
          {}
          <Star className="h-10 w-10 fill-[#001F3F] text-[#001F3F]" />
        </div>
      </div>
    </section>;
}